import React from 'react';
import {Alert, Col, FormGroup, Label, Row} from 'reactstrap';
import Printhead from './printhead';
import Vrate from './vrate';
import FormField from '../../components/Common/FormField';

const gtx300ncnc = () => {
  return (
    <React.Fragment>
      <FormGroup className="mb-4">
        <Label className="col-form-label">Print Head Serials</Label>
        <Alert color="danger" role="alert">
            Please note: the following print head serial numbers are the
            original print heads that are installed with the installation
        </Alert>
        <table style={{width: '100%'}}>
          <tbody>
            <tr>
              <td>
                <Row className="mb-2 px-2">
                  <Label md="2" className="col-form-label">PH Serial colors *</Label>
                  <Col md="4">
                    <Printhead
                      example="BCA0001"
                      name="print_heads[gtx300nc][0][serial]"
                      placeholder="PH Serial colors *"
                    />
                    <FormField
                      name="print_heads[gtx300nc][0][position]"
                      value="1"
                      type="hidden"
                    />
                    <FormField
                      name="print_heads[gtx300nc][0][type]"
                      value="color"
                      type="hidden"
                    />
                  </Col>
                  <Label md="2" className="col-form-label">V.Rating *</Label>
                  <Col md="4">
                    <Vrate name="print_heads[gtx300nc][0][vrate]"/>
                  </Col>
                </Row>
              </td>
            </tr>
            <tr>
              <td>
                <Row className="mb-2 px-2">
                  <Label md="2"
                    className="col-form-label">PH Serial white *</Label>
                  <Col md="4">
                    <Printhead
                      example="BWA0001"
                      name="print_heads[gtx300nc][1][serial]"
                      placeholder="PH Serial white *"
                    />
                    <FormField
                      name="print_heads[gtx300nc][1][position]"
                      value="2"
                      type="hidden"
                    />
                    <FormField
                      name="print_heads[gtx300nc][1][type]"
                      value="white"
                      type="hidden"
                    />
                  </Col>
                  <Label md="2" className="col-form-label">V.Rating*</Label>
                  <Col md="4">
                    <Vrate name="print_heads[gtx300nc][1][vrate]"/>
                  </Col>
                </Row>
              </td>
            </tr>
          </tbody>
        </table>
      </FormGroup>
    </React.Fragment>
  );
};

export default gtx300ncnc;
